import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { InfoPopover } from '../../../../common/InfoPopover/InfoPopover';
import { Box } from '../../../../common/ui/Box';

export const AverageConsumptionTitle = () => {
    return (
        <Box display="flex" alignItems="center" gap={8}>
            <Text variant="title">{translate('vessel.averageConsumption.title')}</Text>
            <InfoPopover>
                <Box width="250px">{translate('vessel.averageConsumption.infoText')}</Box>
            </InfoPopover>
        </Box>
    );
};
